import React from "react";
import {
  Alert,
  AlertDescription,
  Box,
  Icon,
  Text,
} from "@chakra-ui/react";
import alertTriangleIcon from "assets/img/customer/alert-triangle.svg";

export const SuccessCheckIcon = (props: any) => (
  <Icon viewBox="0 0 48 48" {...props}>
    <circle cx="24" cy="24" r="18" fill="none" stroke="#22C55E" strokeWidth="4" />
    <path
      d="M17 24.5l5 5 11-12"
      fill="none"
      stroke="#22C55E"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

interface NotificationProps {
  successMessage?: string;
  errorMessage?: string;
}

export const Notification: React.FC<NotificationProps> = ({
  successMessage,
  errorMessage,
}) => {
  return (
    <>
      {successMessage && (
        <Alert status="success" bg="#E9F7EF" mb="24px" borderRadius="8px">
          <SuccessCheckIcon ml="auto" mr="10px" boxSize="28px" />
          <Text flex="1" fontSize="14px" color="#0B0E10">
            {successMessage}
          </Text>
        </Alert>
      )}
      {errorMessage && (
        <Alert
          status="error"
          mb="24px"
          bgColor="#FEF2F2"
          borderRadius="8px"
          padding="12px 16px"
          justifyContent="center"
        >
          <Box width="100%" display="flex" alignItems="center" textAlign="center">
            <Box
              as="span"
              w="20px"
              h="18px"
              mr="8px"
              bg="#B91C1C"
              flexShrink={0}
              sx={{
                mask: `url(${alertTriangleIcon}) no-repeat center / contain`,
                WebkitMask: `url(${alertTriangleIcon}) no-repeat center / contain`,
              }}
            />
            <AlertDescription
              color="#0B0E10"
              fontSize="14px"
              fontFamily="General Sans"
              fontWeight="400"
              lineHeight="160%"
            >
              {errorMessage}
            </AlertDescription>
          </Box>
        </Alert>
      )}
    </>
  );
};
